<template>
  <component :class="iconClass" :fill="iconFill" :width="iconSize('width') + 'px'" :height="iconSize('height') + 'px'"
    :viewBox="viewBox" :is='icon' />
</template>

<script>
import { defineAsyncComponent } from 'vue'

export default {
  props: {
    name: {
      type: String,
      required: true,
      default: 'placeholder'
    },
    src: {
      type: String,
      required: false
    },
    size: {
      type: String,
      required: false,
      validator: (size) => {
        return ["xs", "s", "m", "l", "xl", "2xl", '3xl'].includes(size);
      },
      default: 'm'
    },
    color: {
      type: String,
      required: false,
      default: 'text-xred-500'
    }
  },

  data() {
    return {
      sizes: {
        xs: "8",
        s: "12",
        m: "18",
        l: "24",
        xl: "32",
        "2xl": "54",
        "3xl": "110",
      },
    }
  },

  methods: {
    iconSize(size) {
      return this.sizes[this.size];
    },
  },

  computed: {
    icon() {
      const name = this.name;

      return defineAsyncComponent(async () => {
        try {
          let component = await import(`../assets/svg/${name}.svg?component`);
          return {
            render: component.render,
            props: ['height', 'width', 'viewBox']
          }
        } catch (e) {
          return {
            render: () => null
          }
        }
      });
    },
    outline() {
      return this.name.includes("-outline");
    },
    iconName() {
      return this.name;
    },
    iconClass() {
      return this.outline
        ? `fill-none stroke-current ${this.color}`
        : ``;
    },
    height() {
      return this.sizes[this.size];
    },
    width() {
      return this.sizes[this.size];
    },
    iconFill() {
      return true;
    },
    viewBox() {
      return `0 0 ${this.height}px ${this.width}px`;
    }
  },
}
</script>
